(() => {
  const root = document.querySelector('#ss-flock-blog');
  if (!root) return;
  const stories = [...root.querySelectorAll('[data-flock-story]')];
  const buttons = [...root.querySelectorAll('[data-flock-topic]')];
  const search = root.querySelector('[data-flock-search]');
  const count = root.querySelector('[data-flock-count]');
  const empty = root.querySelector('[data-flock-empty]');
  const titles = [...root.querySelectorAll('.section-title')];
  let topic = 'All stories';
  root.querySelectorAll('[data-topic-count]').forEach(el => {
    el.textContent = stories.filter(s => el.dataset.topicCount === 'All stories' || s.dataset.topic === el.dataset.topicCount).length;
  });
  function render() {
    const query = (search ? search.value : '').trim().toLowerCase();
    let total = 0;
    let rows = 0;
    stories.forEach(story => {
      const match = (topic === 'All stories' || story.dataset.topic === topic) && story.textContent.toLowerCase().includes(query);
      story.hidden = !match;
      if (match) { total++; if (!story.hasAttribute('data-featured')) rows++; }
    });
    if (count) count.textContent = rows + ' ' + (rows === 1 ? 'story' : 'stories');
    if (empty) empty.hidden = total !== 0;
    titles.forEach(title => { title.hidden = rows === 0; });
  }
  buttons.forEach(button => button.addEventListener('click', () => {
    topic = button.dataset.flockTopic;
    buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    render();
  }));
  if (search) search.addEventListener('input', render);
  render();
})();
